<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<main class="main-site-wrap wrapper">
    <app-header></app-header>
    <div class="site-content-wrap position-relative">
        <app-sidebar *ngIf="loginTrue"></app-sidebar>

        <!--start page wrapper -->
        <div class="page-wrapper" id="texts">
            <div class="page-content">

                <!--breadcrumb-->
                <!-- <div class="page-breadcrumb mb-1 pb-3">
            <div class="row align-items-center">
                <div class="col-12">
                    <h3 class="breadcrumb-title m-0 pe-3">FAQ</h3>
                </div>
            </div>
        </div> -->
                <!--end breadcrumb-->

                <section class="inner-section-wrap pb-5">
                    <div class="card video-card overlapping-card">
                        <div class="card-video-box imgvid-cover" (click)="plays()">
                            <video [src]="Faqdata.video" class="cus_file_overlay w-100 max-height-450" controls type="video/*" style="height:100% !important" id="myAudio1" (click)="plays()"></video>
                        </div>
                        <div class="card-content overlapping-card-content p-3" (click)="plays()">
                            <h3 class="title m-0 white-color p-2"> <span [translate]="'GREATER.TOUR_WELCOME'"> </span> </h3>
                        </div>
                        <div class="play-btn-box" *ngIf="showButton">
                            <a href="javascript:void();"  (click)="plays()">
                                <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_b_4165_2785)">
                                    <circle cx="41" cy="41" r="40" fill="white" fill-opacity="0.2"/>
                                    <circle cx="41" cy="41" r="40" stroke="white" stroke-width="2"/>
                                    </g>
                                    <mask id="mask0_4165_2785" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="17" y="18" width="47" height="47">
                                    <rect x="17" y="18" width="47" height="47" fill="#004FEC"/>
                                    </mask>
                                    <g mask="url(#mask0_4165_2785)">
                                    <path d="M28.3366 50.1804L28.3366 32.8176C28.3366 29.2616 32.201 27.03 35.2853 28.808L42.8147 33.1442L50.344 37.4985C53.4283 39.2765 53.4283 43.7215 50.344 45.4996L42.8147 49.8539L35.2853 54.19C32.201 55.9681 28.3366 53.7546 28.3366 50.1804Z" fill="white"/>
                                    </g>
                                    <defs>
                                    <filter id="filter0_b_4165_2785" x="-27.1828" y="-27.1828" width="136.366" height="136.366" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="13.5914"/>
                                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_4165_2785"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_4165_2785" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>

                            </a>
                        </div>
                    </div>
                    <!-- <div class="row justify-content-center align-items-center py-5">
                        <div class="search-block col-12 col-sm-10 col-lg-8 col-xl-6">
                            <div class="search-box">
                                <input type="text" class="form-control form-search-input" placeholder="{{ 'GREATER.SEARCH' | translate }}..."> <span class="position-absolute top-50 search-show translate-middle-y"><i class='gricon gr_ic_search'></i></span>
                                <span class="position-absolute top-50 search-close translate-middle-y"><i class='gricon gr_ic_close'></i></span>
                            </div>
                        </div>
                    </div> -->
                </section>

                <section class="inner-section-wrap">
                    <div class="row row-cols-1 row-cols-sm-3">

                        <!-- start Coulam -->
                        <div class="col pb-4">
                            <div class="card dark-bg border-radius10 min-height-200">
                                <div class="card-body text-center d-flex align-items-center justify-content-center" (click)="scrollTop()">
                                 <h6 class="title secundaryfont m-0 text-uppercase"><span [translate]="'GREATER.FOR_CREATORS'"> </span> </h6>
                                </div>
                            </div>
                        </div>
                        <!-- End Coulam -->

                        <!-- start Coulam -->
                        <div class="col pb-4">
                            <div class="card dark-bg border-radius10 min-height-200">
                                <div class="card-body text-center d-flex align-items-center justify-content-center" (click)="scrollTop()">
                                 <h6 class="title secundaryfont m-0 text-uppercase"><span [translate]="'GREATER.COMMUNITY'"> </span> </h6>
                                </div>
                            </div>
                        </div>
                        <!-- End Coulam -->

                        <!-- start Coulam -->
                        <div class="col pb-4">
                            <div class="card dark-bg border-radius10 min-height-200">
                                <div class="card-body text-center d-flex align-items-center justify-content-center" (click)="scrollTop()">
                                <h6 class="title secundaryfont m-0 text-uppercase"><span [translate]="'GREATER.FOR_ORGANISATION'"> </span> </h6>
                                </div>
                            </div>
                        </div>
                        <!-- End Coulam -->

                    </div>
                    <!--end row-->
                </section>

                <section class="inner-section-wrap">

                    <div class="row row-cols-1 row-cols-lg-2 pt-5">
                        <!-- start Coulam -->
                        <div class="col pb-4 order-2 order-lg-1">
                            <div class="left-content-box content-box">
                                <h3 class="title secundaryfont pt-3 pb-3 font-w-bold">{{FaqOtherDetail[0].title}} </h3>
                                <div class="faq-list-box" [innerHtml]="FaqOtherDetail[0].description" ></div>
                                <!-- <ul class="list-disc">
                                    <li class="pb-4 font-16">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</li>
                                    <li class="pb-4 font-16">It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</li>
                                    <li class="pb-4 font-16">It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software.</li>
                                    <li class="pb-4 font-16">Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model.</li>
                                </ul> -->
                                <div class="btn-box pt-3">
                                    <a href="javascript:void(0);" class="btn custom-btn gradient1-btn" (click)="downloadFile(FaqOtherDetail[0].content)"> <span [translate]="'GREATER.DOWNLOAD_PDF'"> </span> </a>
                                </div>
                            </div>
                        </div>
                        <!-- End Coulam -->

                        <!-- start Coulam -->
                        <div class="col pb-4 order-1 order-lg-2">
                            <div class="right-img-box img-box imgvid-cover">
                                <img  loading="lazy"  class="border-radius0 min-height-450" [src]="FaqOtherDetail[0].thumbnail"  />
                            </div>
                        </div>
                        <!-- End Coulam -->
                    </div>
                    <!--end row-->

                    <div class="row row-cols-1 row-cols-lg-2 pt-5">
                        <!-- start Coulam -->
                        <div class="col pb-4 order-2">
                            <div class="left-content-box content-box">
                                <h3 class="title secundaryfont pt-3 pb-3 font-w-bold">{{FaqOtherDetail[1].title}}</h3>
                                <div  class="faq-list-box" [innerHtml]="FaqOtherDetail[1].description" ></div>
                                <!-- <ul class="list-disc">
                                    <li class="pb-4 font-16">Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</li>
                                    <li class="pb-4 font-16">It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</li>
                                    <li class="pb-4 font-16">It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software.</li>
                                    <li class="pb-4 font-16">Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model.</li>
                                </ul> -->
                                <div class="btn-box pt-3">
                                    <a href="javascript:void(0);" class="btn custom-btn gradient1-btn" (click)="downloadFile(FaqOtherDetail[1].content)"> <span [translate]="'GREATER.DOWNLOAD_PDF'"> </span> </a>
                                </div>
                            </div>
                        </div>
                        <!-- End Coulam -->

                        <!-- start Coulam -->
                        <div class="col pb-4 order-1">
                            <div class="right-img-box img-box imgvid-cover">
                                <img  loading="lazy"  class="border-radius0" [src]="FaqOtherDetail[1].thumbnail" />
                            </div>
                        </div>
                        <!-- End Coulam -->
                    </div>
                    <!--end row-->

                </section>

                <section class="inner-section-wrap" id="AboutUs">
                    <div class="accordion-block pt-5">
                        <div class="accordion" id="accordionExample">
                            <div class="accordion-item" *ngFor="let item of FaqList">
                                <h2 class="accordion-header" [id]="'heading'+item._id">
                                    <button class="accordion-button collapsed secundaryfont" type="button" data-bs-toggle="collapse" aria-expanded="false" [attr.data-bs-target]="'#collapse'+item._id" [attr.aria-controls]="'collapse'+item._id">
                                {{item.question}}
                            </button>
                                </h2>
                                <div [id]="'collapse'+item._id" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading'+item._id" data-bs-parent="#accordionExample">
                                    <div class="accordion-body">
                                        <div  class="faq-list-box" [innerHtml]="item.answer"> </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                            <button class="accordion-button secundaryfont" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                Programs
                            </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse show" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <strong> This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance,
                                as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>,
                                though the transition does limit overflow.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed secundaryfont" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                Creator Hub
                            </button>
                        </h2>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <strong> This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance,
                                as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>,
                                though the transition does limit overflow.
                            </div>
                        </div>
                    </div> -->
                        </div>
                    </div>
                </section>

            </div>
        </div>
    </div>
    <app-footer></app-footer>
</main>